import React, { useState, useEffect } from "react";
import adminApi from '../../assets/constants/AdminRafservice.Instance';
import { connect } from 'react-redux';
import { dateTimeAdminFormatRender, anchorTagEditMode, statusToFormatRender } from '../../assets/constants/customRender'
import AdminSubHeader from '../../components/home/header/adminSubHeader';
import CardComponent from "../../components/Cards/card";
import ExpandableGridTable from "../../components/TableGrids/ExpandableGridTable.table";
import ServerSideGridTable from "../../components/TableGrids/ServerSideGridTable.table";
import AdminSlider from '../../components/home/header/adminSlider';
import AddUser from '../../components/Dialog/AddUser';
import ViewUser from '../../components/Dialog/ViewUser';
import Button from '@material-ui/core/Button';
import history from "../../history";
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { purple, red } from '@mui/material/colors';
import Swal from 'sweetalert2';
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'react-toastify';

const UsersPage = (props) => {
    const [usersData, setUsersData] = useState([]);
    const [open, setOpen] = useState(false);
    const [viewOpen, setViewOpen] = useState(false);
    const [editUserData, setEditUserData] = useState({});

    const usersColumn = [
        {
            name: "user_id",
            label: "User Id",
        },
        {
            name: "email",
            label: "Email",
        },
        {
            name: "status",
            label: "Status",
            options: statusToFormatRender
        },
        {
            name: "createdAt",
            label: "Created At",
            options: dateTimeAdminFormatRender
        },
        {
            name: "updatedAt",
            label: "Updated At",
            options: dateTimeAdminFormatRender
        },
        {
            name: "id",
            label: "Action",
            options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <>
                            <Tooltip title="View User">
                                <button
                                    className="hyperlink"
                                    style={{ cursor: "pointer", border: "none", background: "none", padding: 0 }}
                                    onClick={() => handleClickViewOpen(value)}
                                    aria-label={`View details of user ${value}`}
                                >
                                    <VisibilityIcon color="primary" />
                                </button>
                            </Tooltip>
                            <Tooltip title="Edit User">
                                <button
                                    className="hyperlink"
                                    style={{ cursor: "pointer", border: "none", background: "none", padding: 0 }}
                                    onClick={() => handleClickOpen(value)}
                                    aria-label={`Edit user ${value}`}
                                >
                                    <ModeEditOutlineIcon color="primary" />
                                </button>
                            </Tooltip>
                            {/* <Tooltip title="Delete User">
                                <button
                                    className="icon-button"
                                    onClick={() => handleClickDelete(value)}
                                    aria-label={`Delete user ${value}`}
                                >
                                    <DeleteRoundedIcon sx={{ color: red[500] }} />
                                </button>
                            </Tooltip> */}
                        </>
                    );
                }
            }
        },
    ];
    
    const usersExpandColumn = [
        {
            name: "user_id",
            label: "Created By",
        },
        {
            name: "user_id",
            label: "Updated By",
        },
    ];
    

    useEffect(() => {
        loadUserData();
    }, [
    ]);

    const handleClickOpen = (value = '') => {
        setOpen(true);
        if (value && value != '') {
            editLoadUserData(value)
        } else {
            setEditUserData({});
        }
    };

    const handleClickViewOpen = (value) => {
        setViewOpen(true);
        editLoadUserData(value);
    };

    const handleViewClose = () => {
        setViewOpen(false);
        setEditUserData({});
    };

    const handleClose = () => {
        setOpen(false);
        setEditUserData({});
    };

    const handleClickDelete = (value) => {
        if (value && value != '') {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this record!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                confirmBtnBsStyle: "success",
                cancelButtonText: 'No, cancel!',
                cancelBtnBsStyle: "danger",
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    adminApi.delete('/user/' + value)
                        .then(res => {
                            Swal.fire({
                                title: 'Deleted!',
                                text: 'Your record has been deleted.',
                                icon: 'success',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                    cancelButton: 'btn btn-danger',
                                }
                            })
                            loadUserData();
                        })
                        .catch(err => {
                            toast.error(err?.response?.data?.message);
                        })
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire({
                        title: 'Cancelled',
                        text: 'Your record is safe :)',
                        icon: 'error',
                        customClass: {
                            confirmButton: 'btn btn-danger',
                            cancelButton: 'btn btn-danger',
                        }
                    })
                }
            })
        }
    };

    const editLoadUserData = (value) => {
        adminApi.get('/user/' + value)
            .then(res => {
                setEditUserData(res.data);
            })
            .catch(err => {
                toast.error(err?.response?.data?.message);
            })
    }

    const loadUserData = () => {
        adminApi.get('/user')
            .then(res => {
                setUsersData(res.data);
            })
            .catch(err => {
                toast.error(err?.response?.data?.message);
            })
    }

    return (
        <div className="container level-summary">
            <div className="row">
                <AdminSubHeader title={'Users'} userPage={true} />
                <div className='col-lg-12 pr-0 pl-0'>
                    <div className="list-member mt-4">
                        <CardComponent
                            heading={`Users`}
                            body={
                                <>
                                    <div>
                                        <AddUser loadUserData={loadUserData} editUserData={editUserData} open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                                        <ViewUser loadUserData={loadUserData} editUserData={editUserData} open={viewOpen} handleClickOpen={handleClickViewOpen} handleClose={handleViewClose} />
                                    </div>

                                    <ExpandableGridTable
                                        data={usersData}
                                        columns={usersColumn}
                                        pagination={true}
                                        subColumns={usersExpandColumn}
                                    ></ExpandableGridTable>
                                </>
                            }></CardComponent>
                    </div>
                </div>
            </div>
        </div>
    )
};
const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
    };
}
export default connect(mapStateToProps)(UsersPage);
